import {Box, HBox} from '@buncha/components/core/view';
import React, {useState} from 'react';

import If from '@buncha/components/conditional/If';
import {Skeleton} from 'native-base';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface StepSkeletonProps {
  index: number;
  totalSteps: number;
}

const StepSkeleton: React.FC<StepSkeletonProps> = ({index, totalSteps}) => {
  const [contentHeight, setContentHeight] = useState(0);
  const theme = useColorThemeType();

  const halfHeight = contentHeight / 2;
  const isFirst = index === 0;
  const isLast = index === totalSteps - 1;
  const getRadius = isFirst ? 25 : 0;
  const getLastRadius = isLast ? 25 : 0;

  return (
    <HBox style={styles.row}>
      <Box style={styles.iconColumn}>
        <Box
          style={[
            styles.halfBar,
            {
              height: halfHeight,
              backgroundColor: isFirst
                ? theme?.background.gray[100]
                : theme?.background.gray[200],
              borderTopLeftRadius: getRadius,
              borderTopRightRadius: getRadius,
            },
          ]}
        />

        <Box
          style={[
            styles.iconSkeleton,
            {
              top: halfHeight - 17,
              backgroundColor: theme?.background.gray[100],
            },
          ]}
        />

        <If condition={true}>
          <Box
            style={[
              styles.halfBar,
              {
                height: halfHeight,
                backgroundColor: isLast
                  ? theme?.background.white[100]
                  : theme?.background.gray[200],
                borderBottomLeftRadius: getLastRadius,
                borderBottomRightRadius: getLastRadius,
              },
            ]}
          />
        </If>
      </Box>

      <Box
        onLayout={e => setContentHeight(e.nativeEvent.layout.height)}
        style={styles.contentContainer}>
        <Box
          style={[
            styles.contentBox,
            {borderColor: theme?.background.gray[200]},
          ]}>
          <If condition={isFirst}>
            <Box style={styles.firstStepContent}>
              <HBox>
                <Skeleton
                  width={'40%'}
                  height={scaleFonts(5)}
                  borderRadius={5}
                />
                <Skeleton
                  width={'40%'}
                  height={scaleFonts(5)}
                  borderRadius={5}
                />
              </HBox>
              <Skeleton width={'90%'} height={scaleFonts(8)} borderRadius={5} />
              <Skeleton
                width={'60%'}
                height={scaleFonts(10)}
                borderRadius={5}
                startColor="yellow.300"
              />
            </Box>
          </If>

          <If condition={!isFirst}>
            <Box style={styles.otherStepContent}>
              <Skeleton width={'55%'} height={scaleFonts(5)} borderRadius={5} />
            </Box>
          </If>
        </Box>
      </Box>
    </HBox>
  );
};

export default React.memo(StepSkeleton);
